<section class="strip-section">
  <div class="strip-head reusable-container">
    <div class="strip-eyebrow">
      <span class="dot"></span>
      Five capabilities. One platform.
    </div>
    <h2 class="strip-title">
      Everything your institution needs,<br />
      <span class="accent">in one unified experience.</span>
    </h2>
  </div>

  <div class="strip-rail reusable-container">
    <!-- 1. Meetings -->
    <article class="spot spot-tall">
      <div class="spot-media">
        <img src="assets/images/meeting2.jpg" alt="HD meetings" />
        <div class="spot-media-grad"></div>
      </div>
      <span class="spot-num">01</span>
      <div class="spot-live">
        <span class="live-dot"></span> Live
      </div>
      <div class="spot-content">
        <div class="spot-icon spot-icon-cyan">
          <mat-icon>videocam</mat-icon>
        </div>
        <h3 class="spot-title">HD Meetings</h3>
        <p class="spot-desc">
          Studio-grade video, lossless audio, instant screen share — tuned for every network.
        </p>
        <div class="spot-meta">Up to 500 attendees</div>
      </div>
    </article>

    <!-- 2. Scheduling -->
    <article class="spot spot-short">
      <div class="spot-media">
        <img src="assets/images/ads/notify.jpg" alt="Scheduling" />
        <div class="spot-media-grad grad-green"></div>
      </div>
      <span class="spot-num">02</span>
      <div class="spot-content">
        <div class="spot-icon spot-icon-green">
          <mat-icon>event</mat-icon>
        </div>
        <h3 class="spot-title">Scheduling</h3>
        <p class="spot-desc">
          Two-way calendar sync. Timezone-smart invites your team actually opens.
        </p>
        <div class="spot-meta">Google · Outlook · ICS</div>
      </div>
    </article>

    <!-- 3. Reservations -->
    <article class="spot spot-mid">
      <div class="spot-media">
        <img src="assets/images/landing/door.jpg" alt="Reservations" />
        <div class="spot-media-grad"></div>
      </div>
      <span class="spot-num">03</span>
      <div class="spot-content">
        <div class="spot-icon spot-icon-primary">
          <mat-icon>meeting_room</mat-icon>
        </div>
        <h3 class="spot-title">Reservations</h3>
        <p class="spot-desc">
          Rooms, auditoriums, shared resources — one calendar, zero conflicts.
        </p>
        <div class="spot-meta">Branch-wide visibility</div>
      </div>
    </article>

    <!-- 4. Reports -->
    <article class="spot spot-tall spot-stat">
      <div class="spot-media">
        <img src="assets/images/meeting4.jpg" alt="Reports" />
        <div class="spot-media-grad grad-dark"></div>
      </div>
      <span class="spot-num">04</span>
      <div class="spot-stat-badge">
        <div class="stat-num">98%</div>
        <div class="stat-trend"><mat-icon>trending_up</mat-icon> +12% QoQ</div>
      </div>
      <div class="spot-content">
        <div class="spot-icon spot-icon-mint">
          <mat-icon>bar_chart</mat-icon>
        </div>
        <h3 class="spot-title">Reports</h3>
        <p class="spot-desc">
          Attendance, duration, decisions — captured automatically for leadership.
        </p>
        <div class="spot-meta">Live dashboards</div>
      </div>
    </article>

    <!-- 5. Institution -->
    <article class="spot spot-mid spot-dark">
      <div class="spot-media">
        <img src="assets/images/landing/ega_building.png" alt="Institution instance" />
        <div class="spot-media-grad grad-dark-heavy"></div>
      </div>
      <span class="spot-num spot-num-light">05</span>
      <div class="spot-content">
        <div class="spot-icon spot-icon-light">
          <mat-icon>apartment</mat-icon>
        </div>
        <h3 class="spot-title spot-title-light">Your Instance</h3>
        <p class="spot-desc spot-desc-light">
          Dedicated environment with your logo, policies, and sovereign hosting.
        </p>
        <a class="spot-cta">
          Request setup <mat-icon>arrow_forward</mat-icon>
        </a>
      </div>
    </article>
  </div>
</section>
